import { Flex, Stack, Text } from "@mantine/core";
import { IconPlant } from "@tabler/icons-react";
import { temperatureColorsToProduct } from "utils/activities";

interface InfoItemProductProps {
  productDescription?: string | null;
  product?: string | null;
  temperatureSetPoint: number | null;
  disabled?: boolean;
}

const InfoItemProduct: React.FC<InfoItemProductProps> = ({
  productDescription,
  product,
  temperatureSetPoint,
  disabled = false,
}) => {
  const temperatureColors = temperatureColorsToProduct(temperatureSetPoint);
  const shouldAddPadding = disabled || temperatureColors.bg === "inherit";

  if (!product) return null;

  return (
    <Flex gap={2} align="center" lh={1}>
      <div className="shrink-0">
        <IconPlant className="text-green-dark" />
      </div>
      <Stack gap={0} className="min-w-0">
        <Text
          c={disabled ? "inherit" : temperatureColors.c}
          bg={disabled ? "inherit" : temperatureColors.bg}
          p={shouldAddPadding ? 0 : 5}
          className="rounded-md self-start"
          lh={1}
          span
        >
          {product}
        </Text>
        {productDescription && (
          <Text
            pl={shouldAddPadding ? 0 : 4}
            lh={1}
            fz={10}
            c={"gray"}
            truncate
          >
            {productDescription}
          </Text>
        )}
      </Stack>
    </Flex>
  );
};

export default InfoItemProduct;
